module.exports = __webpack_public_path__ + "img/motion_sensor_color.c6d5da5d.svg";